export default __webpack_public_path__ + "static/media/postcard_portrait_4x6in.8b9c5b12.png";